import { render, staticRenderFns } from "./listen.vue?vue&type=template&id=643cd58b"
var script = {}
import style0 from "./listen.vue?vue&type=style&index=0&id=643cd58b&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports